import styled from "@emotion/styled";
import {
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import _ from "lodash";
import {
  useServiceTablePage_ServicesQuery,
  useServiceTablePage_DeleteServiceMutation,
} from "../../../../generated/graphql";
import { useTenant } from "../../../context/TenantContext";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../components/DeleteModal";
import { useState } from "react";
import { GroupDropdown } from "../../../components/GroupDropdown";
import { DealershipDropdown } from "../../../components/DealershipDropdown";

const Container = styled("div")`
  margin: 32px;
`;

const CToolbar = styled(Toolbar)`
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
`;

const Title = styled(Typography)`
  flex: 1;
`;

export const ServiceTablePage = () => {
  const { groupId, dealershipId } = useTenant();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState<string | undefined>();
  const [deleteService, { loading: deleteLoading }] =
    useServiceTablePage_DeleteServiceMutation();
  const { data, refetch } = useServiceTablePage_ServicesQuery({
    variables: { groupId: groupId!, dealershipId: dealershipId ?? undefined },
    skip: !groupId,
  });

  return (
    <Container>
      <GroupDropdown />
      <DealershipDropdown />
      <Paper>
        <CToolbar>
          <Title>Serviços</Title>
          <IconButton onClick={() => navigate("/ravpro/services/create")}>
            <Icon>add</Icon>
          </IconButton>
        </CToolbar>
        <Table>
          {data?.services && data?.services.length > 0 ? (
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Código</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {_.orderBy(data?.services, "ServiceCatalog.name").map((row) => (
              <TableRow key={row.uuid} hover>
                <TableCell>{row.ServiceCatalog?.name}</TableCell>
                <TableCell>{row.systemCode}</TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() =>
                      navigate(`/ravpro/services/update/${row.uuid}`)
                    }
                  >
                    <Icon>edit</Icon>
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setDeleteId(row.uuid);
                    }}
                  >
                    <Icon>delete</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {data?.services && data.services.length === 0 ? (
              <TableRow>
                <TableCell align="center">Nenhum registro encontrado</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </Paper>
      <DeleteModal
        open={!!deleteId}
        onClose={() => setDeleteId(undefined)}
        loading={deleteLoading}
        onConfirm={async () => {
          await deleteService({ variables: { uuid: deleteId! } });
          setDeleteId(undefined);
          refetch();
        }}
      />
    </Container>
  );
};
